import useSWR from 'swr';

import { AIConversations } from '@/api/ai-search';
import { ENDPOINTS } from '@/api/endpoints';

export const useConversationsHistory = () => {
  const { data, isLoading, mutate, isValidating } = useSWR(
    ENDPOINTS.AI_SEARCH,
    () => AIConversations(),
    { revalidateOnFocus: false }
  );

  return {
    conversations: data ?? [],
    loading: isLoading,
    validating: isValidating,
    refetchConversations: mutate,
  };
};
